export class LinkMappingTool {
  static avantages: { [key: string]: string } = {
    'titre-restaurant': 'Tickets Restaurant',
    'cheque-vacances': 'Chèques Vacances',
    'bon-essence': 'Bon essence',
    'cheque-cadeau': 'Chèque cadeau entreprise',
  };
  private static mapping: { [key: string]: string } = {
    '/company/titre-restaurant': 'Titres restaurant',
    '/company/cheque-cadeau': 'Chèque cadeau entreprise',
    '/company/cheque-vacances': 'Chèques vacances',
    '/company/bon-essence': "Bons d'essence",
    '/company/solde': 'Solde',
    '/company/profil': 'Profil',
    '/company/aide': 'Aide',
    '/merchant/transactions': 'Mes transactions',
    '/merchant/qr-code': 'Mon Qr-Code',
    '/merchant/kids': 'Mes boutiques & caisses',
    '/merchant/bons': 'Mes bons cadeaux',
    '/merchant/solde': 'Mon solde',
    '/merchant/profil': 'Profil',
    '/merchant/aide': 'Aide',
    '/first-login-change-password': 'Changement mot de passe',
  };

  static mapValue(value: string): string {
    return this.mapping[value] || 'default-value';
  }

  static reverseMapValue(value: string): string {
    const reverseMapping: any = Object.entries(this.mapping).reduce(
      (acc, [key, val]) => ({ ...acc, [val]: key }),
      {},
    );
    return reverseMapping[value] || 'default-reverse-value';
  }
  static getAvantageLabel(id: string): string | undefined {
    return this.avantages[id];
  }
}
